export default "__VITE_ASSET__CPYSA3Qc__"